__turbopack_context__.v({
  "border": "D8Uama_border",
  "menuButton": "D8Uama_menuButton",
  "menuButtonCheck": "D8Uama_menuButtonCheck",
  "nav": "D8Uama_nav",
  "navItem": "D8Uama_navItem",
  "navList": "D8Uama_navList",
  "span": "D8Uama_span",
});
